import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    address: 'Address',
    identity: 'Company identity',
    legalName: 'Legal Name',
    tradeName: 'Trade Name (optional)',
  },
  fr: {
    address: 'Adresse',
    identity: 'Identité de l’entreprise',
    legalName: 'Nom légal',
    tradeName: 'Nom commercial (optionnel)',
  },
} as const);

export default locales;
